import { combineReducers } from 'redux';
import menu from './menu/reducer';

export default combineReducers({ menu });
